import * as React from 'react';
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import GitHubIcon from '@mui/icons-material/GitHub';
import GoogleIcon from '@mui/icons-material/Google';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import { BACKEND_API_URL } from '../data/constant';
import LoginIcon from '@mui/icons-material/Login';
import Cookies from 'js-cookie';
import { useEffect, useRef  } from 'react';
import {
    useAppKitAccount,
    useAppKitProvider,
    useAppKitNetworkCore,
    useAppKit,
} from "@reown/appkit/react";
import {
    BrowserProvider,
    JsonRpcSigner,
    formatEther,
    parseUnits,
} from "ethers"
import { flare } from '@reown/appkit/networks';
import { useNavigate } from 'react-router-dom';



function LoginWithWeb3() {
    // 4. Use modal hook
    const { open } = useAppKit()
    return (
        open().then((response) => {
            // alert("Logged in with web3")
        })
    )
}
function logInWithGithub() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', // Specify the content type as JSON
            credentials: 'include',

        },
    };

    fetch(BACKEND_API_URL + 'oauthlogin/', requestOptions)
        .then((response) => {
            if (!response.ok) {
                console.log(response)
                throw new Error('Network response was not ok');
            }

            return response.json(); // Parse the response JSON
        })
        .then((responseData) => {
            console.log("response from login", responseData)
            const finalURL = responseData.url;
            window.location.href = finalURL;
        })
        .catch((error) => {
            console.error('Fetch error:', error);
        });
}

const GoogleButton = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <>
            <div id="g_id_onload"
                data-client_id="1098827569271-h56raeusf464a2pjiin7tqqe36pad36r.apps.googleusercontent.com"
                data-ux_mode="redirect"
                data-login_uri={BACKEND_API_URL + 'googleoauthcallback/'}
                data-auto_prompt="false"
            >

                <Button

                    variant="outlined"
                    color="neutral"
                    startDecorator={<GoogleIcon />}
                >
                    Sign In
                    <div class="g_id_signin" style={{
                        opacity: "0"
                        , position: "absolute",
                        pointerEvents: "auto"

                    }}>
                    </div>


                </Button>
            </div>
        </>
    );
};

export function VerifyWeb3Login(address, signer, navigate) {
  
    // 3. Fetch a nonce from your backend (Gin server)
    fetch(BACKEND_API_URL + "nonce", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address }),
    }).then((nonceResponse) => {
        
        if (!nonceResponse.ok) {
            throw new Error("Failed to fetch nonce");
        }
        
        return nonceResponse.json();}).then((nonceData) => {
        const { nonce } = nonceData;
        // 4. Sign the nonce with the user's wallet
        signer.signMessage(nonce).then((signature) => {

            // 5. Verify the signature with your backend
            fetch(BACKEND_API_URL + "verify", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ address, signature, nonce }),
            }).then((verificationResponse) => {
                if (!verificationResponse.ok) {
                    throw new Error("Failed to verify signature");
                }
               verificationResponse.json().then((verificationData) => {
                    if (verificationData.redirect) {
                        navigate(verificationData.redirect)
                    }
                    else {
                        alert("Login failed")
                    }
                })
            });
        })

    })

}

export default function LoginPanel() {
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
        // AppKit hook to get the address and check if the user is connected
      const { address, isConnected } = useAppKitAccount();
      // AppKit hook to get the chain id
      const { chainId } = useAppKitNetworkCore();
      // AppKit hook to get the wallet provider
      const { walletProvider } = useAppKitProvider();
    //   const hasTriggered = useRef(false);
    // useEffect(() => {
    //     if (isConnected && Cookies.get('user') == null) {
    //         const walletProvider = window.ethereum;
    //         const provider = new BrowserProvider(walletProvider, chainId);
    //         const signer = new JsonRpcSigner(provider, address);
    //         VerifyWeb3Login(address, signer, navigate)
    //         // hasTriggered.current = true; // Mark as triggered
    //     }
    // }
    //     , [isConnected]);


    return (
        <React.Fragment>
            <Button
                variant="outlined"
                color="neutral"
                startDecorator={<LoginIcon />}
                onClick={() => setOpen(true)}
            >
                Sign In
            </Button>
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog sx={{ textAlign: "center" }}>
                    <Button
                        variant="outlined"
                        color="neutral"
                        startDecorator={<GitHubIcon />}
                        onClick={() => logInWithGithub()}
                    >
                        Sign In
                    </Button>
                    <GoogleButton />
                    <Button
                        variant="outlined"
                        color="neutral"
                        startDecorator={<CurrencyBitcoinIcon />}
                        onClick={() => {
                            setOpen(false)
                            LoginWithWeb3()
                        }}
                    >
                        web3 Sign In
                    </Button>


                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}